/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, lazy, useEffect,useState } from "react"
import { Router, Switch, Route, Redirect } from "react-router-dom"
import { history } from "./history"
import { useDispatch } from "react-redux"
import Spinner from "./components/@vuexy/spinner/Loading-spinner"
import { ContextLayout } from "./utility/context/Layout"
import AuthSession from './helpers/global'
import getNavigationConfig from "./configs/navigationConfig"
import API from "./helpers/api"
// const ServerModules = React.lazy(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./configs/test")), 3000)
//     )
// );

// Route-based code splitting
const Dashboard = lazy(() =>
  import("./views/Dashboard")
)

const NotifyDetail = lazy(() =>
  import("./views/maintenance/NotifyDetail")
)

const ReqNotifyDetail = lazy(() =>
  import("./views/purchasing/RequisitionNotification")
)

const Vessel = lazy(() =>
  import("./views/vessel/Vessel")
)

const HierarchySparepart = lazy(() =>
  import("./views/hierarchy/Sparepart")
)

const HierarchyEquipment = lazy(() =>
  import("./views/hierarchy/Equipment")
)

const Requisition = lazy(() =>
  import("./views/purchasing/Requisition")
)

const PurchasingRFQ = lazy(() =>
  import("./views/purchasing/Rfq")
)

const PurchasingTO = lazy(() =>
  import("./views/purchasing/To")
)

const PurchasingPO = lazy(() =>
  import("./views/purchasing/Po")
)

const HierarchyMaintenance = lazy(() =>
  import("./views/hierarchy/Maintenance")
)

const Maintenance = lazy(() =>
  import("./views/maintenance/Maintenance")
)

const MaintenanceCertificate = lazy(() =>
  import("./views/maintenance/MaintenanceCertificate")
)

const MaintenanceHistory = lazy(() =>
  import("./views/history/History")
)

const CertificateHistory = lazy(() =>
  import("./views/historycert/HistoryCert")
)

const RunningHour = lazy(() =>
  import("./views/runningHour/RunningHour")
)

const Report = lazy(() =>
  import("./views/report/Report")
)

const Export = lazy(() =>
  import("./views/importexport/Export")
)

const Import = lazy(() =>
  import("./views/importexport/Import")
)

const SwingEngine = lazy(() =>
  import("./views/importexport/SwingEngine")
)

const AdministrationUser = lazy(() =>
  import("./views/adm/User")
)

const AdministrationGroup = lazy(() =>
  import("./views/adm/Group")
)

const Account = lazy(() =>
  import("./views/settings/Account")
)

const Measurement = lazy(() =>
  import("./views/settings/Measurement")
)

const Vendor = lazy(() =>
  import("./views/settings/Vendor")
)

const Finding = lazy(() =>
  import("./views/settings/Finding")
)

const Profile = lazy(() =>
  import("./views/profile/Profile")
)

const ProfilePassword = lazy(() =>
  import("./views/profile/Password")
)

const SettingRunningHour = lazy(() =>
  import("./views/settings/RunningHour")
)

const SettingDescription = lazy(() =>
  import("./views/settings/Description")
)

const JobItem = lazy(() =>
  import("./views/settings/JobItem")
)

const Shipping = lazy(() =>
  import("./views/settings/Shipping")
)

const Welcome = lazy(() =>
  import("./views/Welcome")
)

const login = lazy(() =>
  import("./views/Login")
)



const Logout = () =>{

  useEffect(() => {
    API.post('/v1/users/logout')
    AuthSession.clean();
    //window.location.replace('/');
  }, []);

  return(
    <Redirect to="/login" />
  );

}
const Authorized = lazy(() => import("./views/NotAuthorized"))
const error404 = lazy(() => import("./views/404"))
const Error505 = lazy(() => import("./views/505"))
/*
const mapStateToPropsRoute = (state) => {

  return {
    auth: state.auth
    //isLogin: (state.auth.userdata.id) ? true : false
  }
}
*/
// Set Layout and Component Using App Route
//const AppRoute = connect(mapStateToPropsRoute)(({
const AppRoute = ({
  component: MainComponent,
  fullLayout,
  permission,
  user,
  tid: Tid,
  ...rest
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    //console.log('change page')
    if(Tid){
      dispatch({type:'CHANGE_REFRESH_NOTIFY',value: new Date()})
    }
  }, [Tid]);

  return (
    <Route
      {...rest}
      render={props => {

        return (
          <ContextLayout.Consumer>
            {context => {
              let LayoutTag =
                fullLayout === true
                  ? context.fullLayout
                  : context.state.activeLayout === "horizontal"
                  ? context.horizontalLayout
                  : context.VerticalLayout
                return (

                  <Suspense fallback={<Spinner />}>

                      <LayoutTag {...props}>
                        <Suspense fallback={<Spinner />}>
                          <MainComponent {...props} permission={permission || ""} />
                        </Suspense>
                      </LayoutTag>

                  </Suspense>
                )
            }}
          </ContextLayout.Consumer>
        )
      }}
    />
  )
}
/*
const mapStateToPropsPrivate = (state) => {

  return {
    isLogin: AuthSession.isLoggedin(),
    auth: state.auth
    //isLogin: (state.auth.userdata.id) ? true : false
  }
}
*/
//const PrivateRoute = connect(mapStateToPropsPrivate)(({ component: Component, isLogin, ...rest })=>{
const PrivateRoute = ({component: Component, path, ...rest}) => {
  //let isLogin = AuthSession.isLoggedin();


  return <Route
    path={path}
    component={Component}
  />
  /*
  return (
    <Route
      {...rest}
      render={props =>
        <Component {...props} />
      }
    />
  );
  */
}

function PrivateDashboard(){
  const isLogin = AuthSession.isLoggedin();
  const dispatch = useDispatch();
  const [loading,setLoading] = useState(true)
  const [loadingAssets,setLoadingAssets] = useState(true)
  const [loadingUserdata,setLoadingUserdata] = useState(true)
  const [permission,setPermission] = useState({})
  const [route,setRoute] = useState({})
  const [error,setError] = useState('')

  useEffect(() => {

      if(!isLogin){
        return false;
      }

      API.get('/v1/users/profile',{
        callback:({success,data})=>{
          if(success){
            let profile = {
              "tid": data.tid,
              "username": data.username,
              "fullname": data.fullname,
              "email": data.email,
              "date_lastlogin": data.date_lastlogin,
              "is_login": data.is_login,
              "send_notification": data.send_notification,
            }
            dispatch({type:'CHANGE_USERDATA',value: profile})
          }else{
            setError(data)
          }
          setLoadingUserdata(false)
        }
      })

      API.get('/v1/users/assets',{
        'params':{
          page: 1,
          rows: -1,
          sort: JSON.stringify([{"field":'tid_assets',"order":'desc'}]),
        },
        callback: ({success,data})=>{

          if(success){
            let list = data.list || []
            let newAssets = []
            let assetTmp = AuthSession.getAsset() || ""
            let asset = ''
            //console.log(list)
            list.forEach((k)=>{

              if(assetTmp.tid == k.tid_assets){
                asset = {
                  tid: k.tid_assets,
                  title: k.title
                }
              }
              newAssets.push({
                tid: k.tid_assets,
                title: k.title
              })
            })

            dispatch({type:'CHANGE_ASSET',value: asset})
            dispatch({type:'CHANGE_USER_ASSETS',value: newAssets})

          }else{
            setError(data)
          }

          setLoadingAssets(false)

        }
      })

      getNavigationConfig((err,data)=>{

        if(err){
          setError(err)
        }else{

          if(data.length < 1){
            AuthSession.clean();
            return history.push("/misc/not-authorized")
          }

          let permissionAction = []
          let pages = {}
          data.forEach((k)=>{

            //permission_action
            if(k.type === 'action'){
              permissionAction.push(k.key_role)
            }

            pages[k.key_role] = {
              'path': k.navLink,
              'id': k.id
            }

            if(typeof k.permission !== 'undefined'){
              permission[k.key_role] = k.permission
            }

            if(k.children){
              k.children.forEach((k2)=>{
                pages[k2.key_role] = {
                  'path': k2.navLink,
                  'id': k2.id
                }

                if(typeof k2.permission !== 'undefined'){
                  permission[k2.key_role] = k2.permission
                }
              })
            }

          })

          dispatch({type:'CHANGE_PERMISSION_ACTION',value: permissionAction})
          dispatch({type:'CHANGE_USER_NAVIGATION',value: data})
          setRoute(pages)
          setPermission(permission)

        }

        setLoading(false)

      })

  }, []);


  if(!isLogin){
    return window.location.replace('/login')
  }

  if(error){
    return <Error505 error={error} />
  }

  if(loading || loadingAssets || loadingUserdata){
    return <Spinner />
  }

  return(
    <>
      <Switch>

          {
            <AppRoute
              exact
              path="/"
              component={Welcome}
            />
          }

          {
            (!route['dashboard']) ? "" :
            <AppRoute
              exact
              path={route['dashboard'].path}
              component={Dashboard}
              permission={permission['dashboard']}
              tid="10"
            />
          }

          {

            <AppRoute
              exact
              path='/notify'
              component={NotifyDetail}
              permission={permission['maintenance']}
              tid="20"
            />
          }

          {

          <AppRoute
            exact
            path='/req-notify'
            component={ReqNotifyDetail}
            permission={permission['purchasing-requisition']}
            tid="21"
          />
          }


          {
            (!route['assets']) ? "" :
            <AppRoute
              exact
              path={route['assets'].path}
              component={Vessel}
              permission={permission['assets']}
              tid="30"
            />
          }
          {/*
            (!route['assets']) ? "" :
            <AppRoute
              path={route['assets'].path + '/edit/:id'}
              component={Vessel}
              permission={permission['assets']}
            />
          */}


          {
            (!route['purchasing-requisition']) ? "" :
            <AppRoute
              path={route['purchasing-requisition'].path}
              component={Requisition}
              permission={permission['purchasing-requisition']}
              tid="35"
            />
          }

  "       {
            (!route['purchasing-rfq']) ? "" :
            <AppRoute
              path={route['purchasing-rfq'].path}
              component={PurchasingRFQ}
              permission={permission['purchasing-rfq']}
              tid="36"
            />
          }

          { /*
            (!route['purchasing-to']) ? "" :
            <AppRoute
              path={route['purchasing-to'].path}
              component={PurchasingTO}
              permission={permission['purchasing-to']}
              tid="37"
            />
          */}

          {
            (!route['purchasing-po']) ? "" :
            <AppRoute
              path={route['purchasing-po'].path}
              component={PurchasingPO}
              permission={permission['purchasing-po']}
              tid="38"
            />
          }

          {
            (!route['vsh-sparepart']) ? "" :
            <AppRoute
              exact
              path={route['vsh-sparepart'].path}
              component={HierarchySparepart}
              permission={permission['vsh-sparepart']}
              tid="40"
            />
          }

          {
            (!route['vsh-equipment']) ? "" :
            <AppRoute
              exact
              path={route['vsh-equipment'].path}
              component={HierarchyEquipment}
              permission={permission['vsh-equipment']}
              tid="40"
            />
          }

          {
            (!route['vsh-maintenance']) ? "" :
            <AppRoute
              exact
              path={route['vsh-maintenance'].path}
              component={HierarchyMaintenance}
              permission={permission['vsh-maintenance']}
              tid="50"
            />
          }

          {
            (!route['maintenance']) ? "" :
            <AppRoute
              path={route['maintenance'].path}
              component={Maintenance}
              permission={permission['maintenance']}
              tid="60"
            />
          }

          {
            (!route['certificate']) ? "" :
            <AppRoute
              path={route['certificate'].path}
              component={MaintenanceCertificate}
              permission={permission['certificate']}
              tid="60"
            />
          }

          {
            (!route['maintenance-history']) ? "" :
            <AppRoute
              path={route['maintenance-history'].path}
              component={MaintenanceHistory}
              permission={permission['maintenance-history']}
              tid="70"
            />
          }



          {
            (!route['running-hours']) ? "" :
            <AppRoute
              path={route['running-hours'].path}
              component={RunningHour}
              permission={permission['running-hours']}
              tid="80"
            />
          }

          {
            (!route['report-tracking']) ? "" :
            <AppRoute
              path={route['report-tracking'].path}
              component={Report}
              permission={permission['report-tracking']}
              tid="90"
            />
          }

          {
            (!route['export']) ? "" :
            <AppRoute
              path={route['export'].path}
              component={Export}
              permission={permission['export']}
              tid="100"
            />
          }

          {
            (!route['import']) ? "" :
            <AppRoute
              path={route['import'].path}
              component={Import}
              permission={permission['import']}
              tid="101"
            />
          }

          {
            (!route['swing-engine']) ? "" :
            <AppRoute
              path={route['swing-engine'].path}
              component={SwingEngine}
              permission={permission['swing-engine']}
              tid="102"
            />
          }

          {
            (!route['user']) ? "" :
            <AppRoute
              path={route['user'].path}
              component={AdministrationUser}
              permission={permission['user']}
              tid="120"
            />
          }

          {
            (!route['group']) ? "" :
            <AppRoute
              path={route['group'].path}
              component={AdministrationGroup}
              permission={permission['group']}
              tid="130"
            />
          }

          {
            (!route['account']) ? "" :
            <AppRoute
              path={route['account'].path}
              component={Account}
              permission={permission['account']}
              tid="135"
            />
          }

          {
            (!route['measurement']) ? "" :
            <AppRoute
              path={route['measurement'].path}
              component={Measurement}
              permission={permission['measurement']}
              tid="136"
            />
          }


          {
            (!route['vendor']) ? "" :
            <AppRoute
              path={route['vendor'].path}
              component={Vendor}
              permission={permission['vendor']}
              tid="136"
            />
          }

          {
            (!route['shipping']) ? "" :
            <AppRoute
              path={route['shipping'].path}
              component={Shipping}
              permission={permission['shipping']}
              tid="137"
            />
          }

          {
            (!route['finding-library']) ? "" :
            <AppRoute
              path={route['finding-library'].path}
              component={Finding}
              permission={permission['finding-library']}
              tid="140"
            />
          }

          {
            <AppRoute
              exact
              path="/profile"
              component={Profile}
              tid="150"
            />
          }

          {
            <AppRoute
              exact
              path="/profile/password"
              component={ProfilePassword}
              tid="160"
            />
          }

          {
            (!route['asset-running-hours']) ? "" :
            <AppRoute
              path={route['asset-running-hours'].path}
              component={SettingRunningHour}
              permission={permission['asset-running-hours']}
              tid="170"
            />
          }

          {
            (!route['description']) ? "" :
            <AppRoute
              path={route['description'].path}
              component={SettingDescription}
              permission={permission['description']}
              tid="180"
            />
          }

          {
            (!route['jobitem']) ? "" :
            <AppRoute
              path={route['jobitem'].path}
              component={JobItem}
              permission={permission['jobitem']}
              tid="181"
            />
          }

{
            (!route['certificate-history']) ? "" :
            <AppRoute
              path={route['certificate-history'].path}
              component={CertificateHistory}
              permission={permission['certificate-history']}
              tid="190"
            />
          }
          <AppRoute component={error404} fullLayout />

      </Switch>
    </>
  )
}

class AppRouter extends React.Component {
  render() {
    return (
      // Set the directory path if you are deploying in sub-folder
      <Router history={history}>
        <Switch>
          <AppRoute
            path="/login"
            component={login}
            fullLayout
          />

          <AppRoute
            path="/misc/not-authorized"
            component={Authorized}
            fullLayout
          />

          <AppRoute
            path="/logout"
            component={Logout}
            fullLayout
          />

          <PrivateRoute path="/" component={PrivateDashboard} />

        </Switch>
      </Router>
    )
  }
}

export default AppRouter
